import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return ""; }
}

export default function ArticleCard({ article, featured = false }) {
  return (
    <Link
      to={`/artikel/${article.slug}`}
      className={`group block no-underline ${featured ? "md:col-span-2" : ""}`}
      data-testid={`article-card-${article.slug}`}
    >
      <div className={`overflow-hidden mb-5 bg-neutral-100 ${featured ? "" : ""}`} style={{ aspectRatio: featured ? "16/9" : "4/3" }}>
        <img
          src={article.cover_image?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${article.cover_image}` : article.cover_image}
          alt={article.cover_alt || article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="flex items-center gap-3 mb-3">
        <span className="overline">{article.category}</span>
        <span className="text-xs text-neutral-500">·</span>
        <span className="text-xs text-neutral-500">{formatDate(article.published_at)}</span>
        <span className="text-xs text-neutral-500">·</span>
        <span className="text-xs text-neutral-500">{article.reading_time} Min. Lesezeit</span>
      </div>
      <h3
        className={`font-serif ${featured ? "text-3xl md:text-4xl" : "text-2xl"} font-medium leading-tight mb-3 text-brand-dark group-hover:text-brand-primary transition-colors`}
      >
        {article.title}
      </h3>
      <p className="text-neutral-600 leading-relaxed mb-4 line-clamp-3">{article.excerpt}</p>
      <span className="inline-flex items-center gap-1 text-sm text-brand-primary font-medium">
        Weiterlesen <ArrowUpRight size={16} strokeWidth={1.5} />
      </span>
    </Link>
  );
}
